/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-26 10:58:45
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-08 16:04:54
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/BulkEditorTable/slice/index.tsx
 */
import { createSlice, createSelector } from '@reduxjs/toolkit';
import {
  searchConditions,
  getStateTarget as getTarget,
} from 'src/tools/helper';
import { EnumReducers } from 'src/store/constants';
import { onTagClose1 } from 'src/constrains/Query1/tools';

const reducerTarget = (state) => {
  return getTarget(state, [EnumReducers.searchListPageSearchConditions]);
};

const defaultState = {
  // tabsActive: '',
  // searchList: [],
  // searchText: 0,
  // filter: {},
  // sort: {
  //   name: 'Created ( newest )',
  //   key: 8,
  //   data: { field: 'createdDate', ascent: false },
  // },
};
//TODO:Filter单选和多选的问题
const listPageSearchConditions = createSlice({
  name: 'listPageSearchConditions',
  initialState: defaultState,
  reducers: {
    initSearchMap(state, action) {
      const { conditions, key = '' } = action.payload;
      if (!state[key]) {
        state[key] = conditions || { ...searchConditions };
      }
    },
    onSearchChange(state, action) {
      const { search, key = '' } = action.payload;
      const target = state[key] || {};
      target.search.push(search);
    },
    onFilterChange(state, action) {
      const { filter, key: conditionKey = '' } = action.payload;
      const target = state[conditionKey] || {};
      Object.keys(filter).forEach((key) => {
        target.filter[key] = filter[key];
      });
    },
    onSortChange(state, action) {
      const { sort, key = '' } = action.payload;
      const target = state[key] || {};
      target.sort = sort;
    },
    onSearchClose(state, action) {
      const { item, key = '' } = action.payload;

      onTagClose1({ state, item, conditionKey: key });
    },
    emptySearchCondition(state, action) {
      const { key = '' } = action.payload;
      state[key] = { ...searchConditions };
    },
    setTableSetting: (state, action) => {
      const { data, key = '' } = action.payload;
      const target = state[key] || {};
      target.tableSettings = data;
    },
  },
});

const getSearchCondition = (id) => {
  return createSelector(
    (state: any) => {
      return reducerTarget(state)[id];
    },
    (condition) => {
      return condition;
    },
  );
};

export { getSearchCondition };
export const {
  initSearchMap,
  onSearchChange,
  onFilterChange,
  onSortChange,
  onSearchClose,
  emptySearchCondition,
  setTableSetting,
} = listPageSearchConditions.actions;

export default listPageSearchConditions.reducer;
